import jwt from "jsonwebtoken";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const productCategory = {
  state: {
    listProductCategory: [],
    notLevelCategories: [],
    position: 0,
    total: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getProductCategory(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/product_categories/getCategories";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
      })
        .then((res) => res.json())
        .then((result) => {
          if (result)
            this.setState({
              listProductCategory: result.allItems || [],
              notLevelCategories: result.notLevelCategories || [],
            });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async insertProductCategory(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/product_categories/addCategory";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          // if(result.code) {
          //     dispatch.products.getListProduct(rootState)
          // }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateProductCategory(payload = {}, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/product_categories/updateCategory";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          // if(result.code) {
          //     dispatch.products.getListProduct(rootState)
          // }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deleteProductCategory(payload = {}, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/product_categories/deleteCategory";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ id: payload.id }),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          // if(result.code) {
          //     dispatch.products.getListProduct(rootState)
          // }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
  // subscriptions: {
  //     'productCategory/deleteMenuGroup': (action, state, unsubscribe) => {
  //         console.log("***********************subscriptions");
  //         dispatch.products.setState({})
  //         console.log(action);
  //         console.log(state);
  //     //   dispatch.settings.set(action.payload)
  //     }
  // }
};

export default productCategory;
